export const doctorSpecialties = [
    {
        "id": 44,
        "name": "ΝΕΥΡΟΛΟΓΟΣ-ΨΥΧΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 11534.97,
        "enforceLimit": true
    },
    {
        "id": 45,
        "name": "ΠΑΘΟΛΟΓΟΣ-ΟΓΚΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 45450.68,
        "enforceLimit": true
    },
    {
        "id": 47,
        "name": "ΚΛΙΝΙΚΗ ΧΗΜΕΙΑ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": null,
        "enforceLimit": false
    },
    {
        "id": 22,
        "name": "ΑΓΓΕΙΟΧΕΙΡΟΥΡΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 871.58,
        "enforceLimit": true
    },
    {
        "id": 23,
        "name": "ΑΙΜΑΤΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 23661.56,
        "enforceLimit": true
    },
    {
        "id": 24,
        "name": "ΑΚΤΙΝΟΔΙΑΓΝΩΣΤΗΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 987.33,
        "enforceLimit": true
    },
    {
        "id": 25,
        "name": "ΑΚΤΙΝΟΘΕΡΑΠΕΥΤΗΣ-ΟΓΚΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 2498.8,
        "enforceLimit": true
    },
    {
        "id": 1,
        "name": "ΑΛΛΕΡΓΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 5185.34,
        "enforceLimit": true
    },
    {
        "id": 26,
        "name": "ΑΝΑΙΣΘΗΣΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 1023.32,
        "enforceLimit": true
    },
    {
        "id": 50,
        "name": "ΑΚΤΙΝΟΔΙΑΓΝΩΣΤΗΣ - ΕΠΕΜΒΑΤΙΚΟΣ ΑΚΤΙΝΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 987.33,
        "enforceLimit": true
    },
    {
        "id": 3,
        "name": "ΓΑΣΤΡΕΝΤΕΡΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 4832.61,
        "enforceLimit": true
    },
    {
        "id": 4,
        "name": "ΓΕΝΙΚΗ/ΟΙΚΟΓΕΝΕΙΑΚΗ ΙΑΤΡΙΚΗ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 13988.12,
        "enforceLimit": true
    },
    {
        "id": 27,
        "name": "ΓΝΑΘΟΠΡΟΣΩΠΙΚΟΣ ΧΕΙΡΟΥΡΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 178.03,
        "enforceLimit": true
    },
    {
        "id": 5,
        "name": "ΜΑΙΕΥΤΗΡΑΣ-ΓΥΝΑΙΚΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 1575.11,
        "enforceLimit": true
    },
    {
        "id": 6,
        "name": "ΔΕΡΜΑΤΟΛΟΓΟΣ-ΑΦΡΟΔΙΣΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 2887.61,
        "enforceLimit": true
    },
    {
        "id": 7,
        "name": "ΕΛΕΓΚΤΗΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 6699.49,
        "enforceLimit": false
    },
    {
        "id": 8,
        "name": "ΕΝΔΟΚΡΙΝΟΛΟΓΙΑ - ΔΙΑΒΗΤΗΣ - ΜΕΤΑΒΟΛΙΣΜΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 5240.46,
        "enforceLimit": true
    },
    {
        "id": 28,
        "name": "ΙΑΤΡΙΚΗ ΤΗΣ ΕΡΓΑΣΙΑΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 504.27,
        "enforceLimit": true
    },
    {
        "id": 29,
        "name": "ΙΑΤΡΟΔΙΚΑΣΤΗΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 5733.76,
        "enforceLimit": false
    },
    {
        "id": 9,
        "name": "ΚΑΡΔΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 5626.26,
        "enforceLimit": true
    },
    {
        "id": 30,
        "name": "ΙΑΤΡΙΚΗ ΤΗΣ ΔΗΜΟΣΙΑΣ ΥΓΕΙΑΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 4506.48,
        "enforceLimit": false
    },
    {
        "id": 31,
        "name": "ΚΥΤΤΑΡΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 438.48,
        "enforceLimit": true
    },
    {
        "id": 32,
        "name": "ΜΙΚΡΟΒΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 2296.85,
        "enforceLimit": true
    },
    {
        "id": 10,
        "name": "ΝΕΥΡΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 15509.44,
        "enforceLimit": true
    },
    {
        "id": 33,
        "name": "ΝΕΥΡΟΧΕΙΡΟΥΡΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 439.12,
        "enforceLimit": true
    },
    {
        "id": 34,
        "name": "ΝΕΦΡΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 12902.52,
        "enforceLimit": true
    },
    {
        "id": 35,
        "name": "ΟΔΟΝΤΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 36.93,
        "enforceLimit": true
    },
    {
        "id": 36,
        "name": "ΟΡΘΟΔΟΝΤΙΚΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 9.22,
        "enforceLimit": false
    },
    {
        "id": 11,
        "name": "ΟΡΘΟΠΕΔΙΚΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 2023.79,
        "enforceLimit": true
    },
    {
        "id": 12,
        "name": "ΟΥΡΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 2809.83,
        "enforceLimit": true
    },
    {
        "id": 13,
        "name": "ΟΦΘΑΛΜΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 1210.0,
        "enforceLimit": true
    },
    {
        "id": 37,
        "name": "ΠΑΘΟΛΟΓΟΑΝΑΤΟΜΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 80.44,
        "enforceLimit": true
    },
    {
        "id": 14,
        "name": "ΠΑΘΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 10206.51,
        "enforceLimit": true
    },
    {
        "id": 15,
        "name": "ΠΑΙΔΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 3155.33,
        "enforceLimit": true
    },
    {
        "id": 38,
        "name": "ΧΕΙΡΟΥΡΓΟΣ ΠΑΙΔΩΝ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 274.13,
        "enforceLimit": true
    },
    {
        "id": 39,
        "name": "ΠΑΙΔΟΨΥΧΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 459.95,
        "enforceLimit": true
    },
    {
        "id": 40,
        "name": "ΠΛΑΣΤΙΚΟΣ ΧΕΙΡΟΥΡΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 135.54,
        "enforceLimit": true
    },
    {
        "id": 16,
        "name": "ΠΝΕΥΜΟΝΟΛΟΓΟΣ-ΦΥΜΑΤΙΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 4947.87,
        "enforceLimit": true
    },
    {
        "id": 17,
        "name": "ΡΕΥΜΑΤΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 26578.68,
        "enforceLimit": true
    },
    {
        "id": 18,
        "name": "ΦΑΡΜΑΚΟΠΟΙΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": null,
        "enforceLimit": false
    },
    {
        "id": 41,
        "name": "ΦΥΣΙΚΗ ΙΑΤΡΙΚΗ-ΑΠΟΚΑΤΑΣΤΑΣΗΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 1385.54,
        "enforceLimit": true
    },
    {
        "id": 19,
        "name": "ΧΕΙΡΟΥΡΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 664.31,
        "enforceLimit": true
    },
    {
        "id": 42,
        "name": "ΧΕΙΡΟΥΡΓΟΣ ΘΩΡΑΚΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 396.01,
        "enforceLimit": true
    },
    {
        "id": 20,
        "name": "ΨΥΧΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 5487.27,
        "enforceLimit": true
    },
    {
        "id": 21,
        "name": "ΩΤΟΡΙΝΟΛΑΡΥΓΓΟΛΟΓΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 696.83,
        "enforceLimit": true
    },
    {
        "id": 46,
        "name": "ΙΑΤΡΙΚΗ ΒΙΟΠΑΘΟΛΟΓΙΑ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 218.28,
        "enforceLimit": false
    },
    {
        "id": 48,
        "name": "ΠΥΡΗΝΙΚΟΣ ΙΑΤΡΟΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 1697.63,
        "enforceLimit": true
    },
    {
        "id": 49,
        "name": "ΑΝΕΥ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 3227.44,
        "enforceLimit": true
    },
    {
        "id": 51,
        "name": "ΙΑΤΡΙΚΗ ΓΕΝΕΤΙΚΗ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 28.22,
        "enforceLimit": true
    },
    {
        "id": 43,
        "name": "ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΓΕΝΙΚΗΣ ΙΑΤΡΙΚΗΣ",
        "icd10Compulsory": true,
        "monthlyPharmaceuticalCost": 11411.1,
        "enforceLimit": true
    }
]